import React from 'react';

export const Logo = ({ href, imageUrl }) => {
    const anchorStyle = imageUrl
        ? {
              background: `url(${imageUrl}) no-repeat`,
          }
        : undefined;

    return (
        <div className="header-actions-logo">
            <a href={href} className="header-actions-logo--brand" style={anchorStyle} />
        </div>
    );
};
